import request from '@/utils/request'

export const getProductList = () =>
  request({
    url: '/products/list',
    method: 'get',
    timeout: 30 * 1000
  })
export const getProductForEdit = (productId: string) =>
  request({
    url: `/products/${productId}`,
    method: 'get'
  })

export const splitVariants = newVariantGroups =>
  request({
    url: `/products/splitVariants`,
    method: 'post',
    data: { newVariantGroups }
  })
export const getTagList = () =>
  request({
    url: `/products/tags`,
    method: 'get'
  })

export const createProduct = formData =>
  request({
    url: '/products/create',
    method: 'post',
    data: formData,
    timeout: 60 * 1000
  })
export const updateProduct = formData =>
  request({
    url: '/products/update',
    method: 'post',
    data: formData,
    timeout: 60 * 1000
  })
export const archiveProduct = (id: number) =>
  request({
    url: '/products/archive',
    method: 'post',
    data: { id }
  })
export const getProductSnapshot = (id: string, rev: string) =>
  request({
    url: `/products/snapshot/${id}/${rev}`,
    method: 'get'
  })
